class Collection {
  constructor() {
    this.selectors = {
      section: ".facest-filters-section",
      toolbar: ".m-collection-toolbar",
      productContainer: "[data-product-container]",
      loadMoreBtn: "[data-load-more]",

      sidebar: ".m-sidebar",
      sidebarContent: ".m-sidebar--content",
      openSidebar: ".m-sidebar--open",
      closeSidebar: ".m-sidebar--close",
      filtersWrapper: ".m-filter--wrapper",
    };

    this.mobileSortingSelectors = {
      openSorting: ".m-sortby--open",
      closeSorting: ".m-sortby-mobile--close",
      sortingWrapper: ".m-sortby-mobile--wrapper",
      sortingList: ".m-sortby-mobile--content",
    };

    this.sectionId = "";
    this.isDesignMode = MinimogSettings.design_mode;

    this.currentPage = 1;
    this.paginationType = null;
    this.totalPages = 1;
    this.totalProducts = 0;
    this.infiniteLoadingObserver = null;

    this.MAX_COL_BY_SCREEN_SIZE = {
      mobile: 2,
      tablet: 4,
      desktop: 5,
    };

    this.enableFilters = false;
    this.enableSorting = false;
    this.filtersType = "";
    this.filtersPosition = "";
    this.accordions = null;

    this.sideEffectEventsAdded = false;
    this.stickyToolbarBound = false;
    this.lastScroll = 0;
  }

  init = () => {
    this.domNodes = queryDomNodes(this.selectors);
    this.mbSortingNodes = queryDomNodes(this.mobileSortingSelectors);

    if (!this.domNodes.section) return;

    this.setData();
    this.initGridView();
    this.initFilters();
    this.initMobileSorting();
    this.initProducts();

    if (!this.sideEffectEventsAdded) {
      this.sideEffectEventsAdded = true;

      if (typeof MinimogEvents !== "undefined") {
        MinimogEvents.subscribe("ON_PRODUCT_LIST_UPDATED", () => {
          if (typeof refreshProductReview === "function") refreshProductReview();
        });
      }

      document.addEventListener("matchMobile", () => this.handleStickyToolbar());
      document.addEventListener("unmatchMobile", () => this.handleStickyToolbar());
    }

    this.handleStickyToolbar();
  };

  setData = () => {
    const { section, productContainer } = this.domNodes;
    if (!section) return;

    this.sectionId = section.dataset.sectionId || "";
    this.paginationType = section.dataset.paginationType || "paginate";
    this.totalPages = productContainer ? Number(productContainer.dataset.totalPages || 1) : 1;
    this.view = section.dataset.view || "";
    this.currentPage = 1;

    this.enableFilters = section.dataset.enableFilters === "true";
    this.enableSorting = section.dataset.enableSorting === "true";
    this.filtersType = section.dataset.filtersType || "";
    this.filtersPosition = section.dataset.filtersPosition || "";
  };

  initGridView = () => {
    this.initLoadMore();
  };

  initFilters = () => {
    if (!this.enableFilters) return;

    const { sidebar, openSidebar, closeSidebar, filtersWrapper } = this.domNodes;

    if (filtersWrapper && typeof MinimogLibs !== "undefined" && MinimogLibs.Accordion) {
      window.requestAnimationFrame(this.initAccordions);
    }

    if (openSidebar) {
      openSidebar.addEventListener("click", this.openSidebarFilter);
    }

    if (closeSidebar) {
      closeSidebar.addEventListener("click", this.closeSidebarFilter);
    }

    if (sidebar) {
      sidebar.addEventListener("click", (e) => {
        if (e.target === sidebar) this.closeSidebarFilter();
      });
    }
  };

  initMobileSorting = () => {
    if (!this.enableSorting) return;

    const { openSorting, closeSorting, sortingWrapper } = this.mbSortingNodes || {};

    if (openSorting) {
      openSorting.addEventListener("click", this.openMobileSorting);
    }

    if (closeSorting) {
      closeSorting.addEventListener("click", this.closeMobileSorting);
    }

    if (sortingWrapper) {
      sortingWrapper.addEventListener("click", (e) => {
        if (e.target === sortingWrapper) this.closeMobileSorting();
      });
    }
  };

  openMobileSorting = () => {
    const { sortingWrapper, sortingList } = this.mbSortingNodes || {};
    if (!sortingWrapper || !sortingList) return;

    sortingWrapper.style.display = "block";

    window.requestAnimationFrame(() => {
      sortingWrapper.style.setProperty("--m-bg-opacity", "0.5");
      sortingList.style.setProperty("--m-translate-y", "0");
    });
  };

  closeMobileSorting = () => {
    const { sortingWrapper, sortingList } = this.mbSortingNodes || {};
    if (!sortingWrapper || !sortingList) return;

    sortingWrapper.style.setProperty("--m-bg-opacity", "0");
    sortingList.style.setProperty("--m-translate-y", "100%");

    setTimeout(() => {
      sortingWrapper.style.setProperty("display", "none");
    }, 300);
  };

  initAccordions = () => {
    const { filtersWrapper } = this.domNodes;
    if (!filtersWrapper) return;

    if (this.accordions && typeof this.accordions.destroy === "function") {
      this.accordions.destroy();
    }

    filtersWrapper.classList.remove("acc-initialized");

    this.accordions = new MinimogLibs.Accordion(filtersWrapper, {
      presetContentHeight: window.innerWidth > 1280 && this.filtersPosition !== "fixed",
      callback: () => filtersWrapper.style.setProperty("opacity", "1"),
    });
  };

  openSidebarFilter = () => {
    const { sidebar, sidebarContent, section } = this.domNodes;
    if (!sidebar || !sidebarContent || !section) return;

    sidebar.style.display = "block";

    window.requestAnimationFrame(() => {
      sidebar.style.setProperty("--m-bg-opacity", "0.5");
      sidebarContent.style.setProperty("--m-translate-x", "0");

      if (this.accordions && typeof this.accordions.setContentHeight === "function") {
        this.accordions.setContentHeight();
      }
    });

    section.classList.add("sidebar-open");
  };

  closeSidebarFilter = () => {
    const { sidebar, sidebarContent, section } = this.domNodes;
    if (!sidebar || !sidebarContent || !section) return;

    section.classList.remove("sidebar-open");

    if (window.innerWidth < 1280 || sidebar.dataset.type === "fixed") {
      sidebarContent.style.setProperty("--m-translate-x", "-100%");
      sidebar.style.removeProperty("--m-bg-opacity");

      setTimeout(() => {
        sidebar.style.removeProperty("display");
      }, 300);
    }
  };

  initLoadMore = () => {
    if (this.paginationType === "paginate" || this.totalPages <= 1 || this.view === "search") return;

    const { loadMoreBtn } = this.domNodes;
    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener("click", this.loadMoreProducts);

    if (this.paginationType === "infinite") {
      this.infiniteLoadingObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio === 1) this.loadMoreProducts();
          });
        },
        { threshold: 1 }
      );

      this.infiniteLoadingObserver.observe(loadMoreBtn);
    }
  };

  loadMoreProducts = () => {
    const nextPage = this.currentPage + 1;
    if (nextPage > this.totalPages) return;

    const { productContainer, loadMoreBtn } = this.domNodes;
    if (!productContainer || !loadMoreBtn) return;

    this.toggleLoading(true);

    fetchSection(this.sectionId, {
      fromCache: true,
      params: { page: nextPage },
    })
      .then((productGridHTML) => {
        const productNodes = productGridHTML.querySelectorAll(
          "[data-product-container] .m-product-item"
        );

        productNodes.forEach((prodNode) => {
          productContainer.appendChild(prodNode);
        });

        this.initProducts();
      })
      .catch((err) => console.error("Failed to load more products.", err))
      .finally(() => {
        if (typeof MinimogEvents !== "undefined") {
          MinimogEvents.emit("ON_PRODUCT_LIST_UPDATED");
        }

        this.toggleLoading(false);
        this.currentPage = nextPage;

        if (nextPage >= this.totalPages) {
          if (loadMoreBtn.parentNode) loadMoreBtn.parentNode.remove();

          if (this.infiniteLoadingObserver) {
            this.infiniteLoadingObserver.unobserve(loadMoreBtn);
          }
        }
      });
  };

  initProducts = () => {
    if (MinimogTheme.CompareProduct) {
      MinimogTheme.CompareProduct.setCompareButtonsState();
    }

    if (MinimogTheme.Wishlist) {
      MinimogTheme.Wishlist.setWishlistButtonsState();
    }
  };

  toggleLoading = (loading) => {
    const { loadMoreBtn } = this.domNodes;
    if (!loadMoreBtn) return;

    loadMoreBtn.classList[loading ? "add" : "remove"]("m-spinner-loading");
  };

  handleStickyToolbar = () => {
    const toolbar = this.domNodes && this.domNodes.toolbar;
    if (!toolbar) return;

    if (this.stickyToolbarBound) return;
    this.stickyToolbarBound = true;

    const onScroll = () => {
      const extraSpace = toolbar.offsetTop || 0;

      if (MinimogTheme.config && MinimogTheme.config.mqlMobile) {
        const currentScroll = window.scrollY;

        if (currentScroll <= extraSpace) {
          toolbar.classList.remove("scroll-up", "m-collection-toolbar--sticky", "scroll-down");
          return;
        }

        toolbar.classList.add("m-collection-toolbar--sticky");

        if (
          currentScroll > toolbar.offsetHeight + extraSpace &&
          currentScroll > this.lastScroll &&
          !toolbar.classList.contains("scroll-down")
        ) {
          toolbar.classList.remove("scroll-up");
          toolbar.classList.add("scroll-down");
        } else if (
          currentScroll < this.lastScroll &&
          toolbar.classList.contains("scroll-down")
        ) {
          toolbar.classList.remove("scroll-down");
          toolbar.classList.add("scroll-up");
        }

        this.lastScroll = currentScroll;
      } else {
        toolbar.classList.remove("scroll-up", "m-collection-toolbar--sticky", "scroll-down");
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  };
}